// Too many attempts
export const SIGN_UP_ATTEMPT_KEY = 'timerSignUpAttempt';
export const SIGN_UP_ATTEMPT_SEEN_KEY = 'timerSignUpAttemptSeen';

export const DEFAULT_LOCALE = 'en';
export const countryDefaultLanguage = {
  NO: 'no',
  DK: 'dk',
  GL: 'dk',
  DE: 'de',
  AT: 'de',
  CH: 'de',
  LI: 'de',
  LU: 'de',
  PL: 'pl',
  AR: 'es',
  CL: 'es',
  CO: 'es',
  CR: 'es',
  CU: 'es',
  EC: 'es',
  ES: 'es',
  GQ: 'es',
  GT: 'es',
  HN: 'es',
  MX: 'es',
  NI: 'es',
  PA: 'es',
  PE: 'es',
  PY: 'es',
  SV: 'es',
  UY: 'es',
  BO: 'es',
  VE: 'es',
  DO: 'es',
  PR: 'es',
  FR: 'fr',
  MC: 'fr',
  IT: 'it',
  FI: 'fi',
  EE: 'ee',
  /**rework after: slovakia sl to si */
  SL: 'sl',
  SI: 'sl',
};
